// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w8Pc","col":"styles_col__3ytnA"};